module.exports = require("@mui/material/Avatar");